<template>
  <div class="settings-page">
    <div class="main-wrapper">
      <div class="content main_content">
        <side-menu></side-menu>

        <settings-sidebar></settings-sidebar>
      </div>

      <settings-modal></settings-modal>
    </div>
  </div>
</template>
